// extracted by mini-css-extract-plugin
export default {"combination":"CombinationDocumentChip_combination__fz17B"};